module.exports = __webpack_public_path__ + "static/media/Car-step-icon-white.286b1602.svg";